import { render, staticRenderFns } from "./ContractAmendment.vue?vue&type=template&id=0827759b&scoped=true"
import script from "./ContractAmendment.vue?vue&type=script&lang=js"
export * from "./ContractAmendment.vue?vue&type=script&lang=js"
import style0 from "./ContractAmendment.vue?vue&type=style&index=0&id=0827759b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827759b",
  null
  
)

export default component.exports